module.exports = __webpack_public_path__ + "img/背景1.1aebf1c0.jpg";